export const MIN_PROGNOSIS_AGE = 6;
export const MAX_PROGNOSIS_AGE = 20;
